import { InjectionToken } from '@angular/core';
import { Configuration } from 'msal';

export interface MsalConfiguration {
  config: Configuration;
  scopes: string[];
  extraScopesToConsent: string[];
}
export const AUTH_CONFIG = new InjectionToken<MsalConfiguration>('AUTH_CONFIG');
